export default {
  component: {
    exhibitorDirectory: 'exhibitor directory',
    exhibitorDirectoryOverlay: 'exhibitor directory overlay',
    exhibitorDetails: 'exhibitor details',
    productDirectory: 'product directory',
    productDetails: 'product details',
    homePage: 'home page',
    exhibitorHub: 'exhibitor hub',
    eventPortal: 'event portal'
  },
  subComponent: {
    priority: 'priority',
    standard: 'standard'
  },
  packageName: {
    gold: 'gold',
    silver: 'silver'
  },
  profileSection: {
    filterCategories: 'filter categories',
    companyAdmin: 'company admin'
  },
  type:{
    exhibitor: 'exhibitor',
    product: 'product'
  },
  eventName: {
    addToShowPlan: 'Plan Added',
    removeFromShowPlan: 'Plan Removed',
    exhibitorClicked: 'Exhibitor Interacted',
    productInteracted: 'Product Interacted',
    exhibitorImpression: 'Exhibitor Impression',
    productImpression: 'Product Impression',
    documentImpression: 'Document Impression',
    documentDownloaded: 'Document Downloaded',
    digitalPackageInteracted: 'Digital Package Interacted',
    exhibitorContactInfo: 'Contact Info Interacted',
    documentClicked: 'Document Clicked',
    sortOrderSelected: 'Sort Order Selected',
    productClicked: 'Product Clicked',
    productEdited: 'Product Edited',
    productCancel: 'Product Cancel',
    dashboardComponentViewed:'Dashboard Component Viewed',
    exhibitorDashboardInteracted:'Exhibitor Dashboard Interacted',
    tabSwitch: 'Tab Switch',
    exhibitorHubVisited: 'Exhibitor Hub Visited',
    communicationRequested: 'Communication Requested',
    exhibitorProfileSaved: 'Exhibitor Profile Saved',
    exhibitorDirectoryVisited: 'Exhibitor Directory Visited',
    exhibitorDetailsVisited: 'Exhibitor Details Visited',
    productDirectoryVisited: 'Product Directory Visited',
    productDetailsVisited: 'Product Details Visited',
    leadTileInteracted:'Lead Tile Interacted',
    leadBoosterInteracted: 'Lead Booster Interacted',
    twoFactorSaved: 'Two Factor Saved',
    productVideoPlayed: 'Product Video Played',
    companyAdminInteracted: 'Company Admin Interacted',
    manageSharerInteracted: 'Manage Sharer Interacted',
    operationsTasksInteracted: 'Operations Tasks Interacted'
  },
  eventProperties: {
    exhibitorId : 'Exhibitor ID',
    exhibitorName: 'Exhibitor Name',
    packageType: 'Package Type',
    productArea: 'Product Area',
    component: 'Component',
    entityAdded: 'Entity Added',
    entityRemoved: 'Entity Removed',
    productId: 'Product ID',
    productName: 'Product Name',
    element: 'Interacted Element',
    viewedElement: 'Viewed Element',
    subComponent: 'Slot Type',
    documentName: 'Document Name',
    documentType: 'Document Type',
    downloadUrl: 'Download URL',
    type: 'Type',
    contactType: 'Contact Type',
    socialMedia: 'Social Media',
    sortOption: 'Sort Option',
    tabName: 'Tab Name',
    profileSection: 'Profile Section',
    eventEditionId: 'Event Edition ID',
    eventEditionName: 'Event Edition Name',
    source: 'Source',
    leadBoosterStatus: 'Lead Booster Status',
    twoFactor: 'Two Factor Enabled',
    videoId: 'Video Id',
    playDuration: 'Playing Duration',
    totalVideoDuration: 'Total Video Duration',
    percentageWatched: 'Percentage Watched',
    actionOnVideo: 'Action on Video',
    hubVersion: 'Hub Version',
    adminRole: 'Admin Role',
    sharerPackage: 'Sharer Package',
    operationalTaskName: 'Operational Task Name',
    taskCategory: 'Task Category',
    taskStatus: 'Task Status',
    completionStatus: 'Completion Status'
  },
  propertyValue: {
    exhibitors: 'exhibitors',
    exhibitorHub: 'Exhibitor Hub',
    exhibitorDashboard: 'Exhibitor Dashboard',
    mercury: 'Mercury',
    exhibitorDashboardStaticTile: 'Exhibitor Dashboard Static Tile',
    exhibitorDashboardLiveTile: 'Exhibitor Dashboard Live Tile',
    exhibitorDashboardOldTile: 'Exhibitor Dashboard Old Tile',
    exhibitorDashboardTile: 'Exhibitor Dashboard Tile',
    leadBooster: {
      title: 'Offers',
      hubTile: 'Hub Lead Booster Tile',
      salesCta: 'Sales CTA',
      vasCta: 'VAS CTA',
      notPurchased: 'Not Purchased',
      fulfilled: 'Fulfilled',
      notFulfilled: 'Not Fulfilled'
    },
    actionOnVideo: {
      videoPaused: 'pause',
      closedOverlay: 'closed overlay',
      leftViewport: 'left viewport',
      navigatedAway: 'navigated away'
    },
    version: 'v1',
    newHubVersion: 'v2',
    adminRole: {
      primary: 'primary',
      secondary: 'secondary'
    },
    taskStatus: {
      mandatory: 'mandatory',
      optional: 'optional'
    },
    completionStatus: {
      notStarted: 'not started',
      inProgress: 'in progress',
      overdue: 'overdue',
      completed: 'completed'
    }
  },
  element: {
    logo: 'logo',
    exhibitorTitle: 'exhibitor title',
    description: 'description',
    brands: 'brands',
    viewAllProducts: 'view all products',
    mainStandHolderTitle: 'main stand holder title',
    showObjective: 'show objective',
    filterTag: 'filter tag',
    goldCarousel: 'gold carousel',
    navigationArrows: 'navigation arrows',
    documentCarouselChevron: 'document carousel chevron',
    productCarouselChevron: 'product carousel chevron',
    moreStands: 'more stands',
    productTitle: 'product title',
    productImage: 'product image',
    productVideo: 'product video',
    productEdited: 'product edited',
    imageUploaded: 'image uploaded',
    videoUploaded: 'video uploaded',
    imageEdited: 'image edited',
    videoEdited: 'video edited',
    thumbnailDeleted: 'thumbnail deleted',
    thumbnailAdded: 'thumbnail added',
    videoUploadCanceled: 'video upload canceled',
    videoDeleted: 'video deleted',
    toggleOff: 'toggle off',
    toggleOn: 'toggle on',
    documentTitle: 'document title',
    documentImage: 'document image',
    overlayProductLink: 'overlay product link',
    overlayChevron: 'overlay chevron',
    sharerTitle: 'sharer title',
    activationEmail: 'activation email',
    showAllProducts: 'show all products',
    showLessProducts: 'show less products',
    showAllDocuments: 'show all documents',
    showLessDocuments: 'show less documents',
    showLessCategories: 'show less categories',
    showAllCategories: 'show all categories',
    addAdminClicked: 'add_admin_clicked',
    editAdminClicked: 'edit_admin_clicked',
    deleteAdminClicked: 'delete_admin_clicked',
    saveAddAdminClicked: 'save_add_admin_clicked',
    cancelAddAdminClicked: 'cancel_add_admin_clicked',
    saveEditAdminClicked: 'save_edit_admin_clicked',
    cancelEditAdminClicked: 'cancel_edit_admin_clicked',
    addStandSharerClicked: 'add_stand_sharer_clicked',
    cancelStandSharerClicked: 'cancel_stand_sharer_clicked',
    createStandSharerClicked: 'create_stand_sharer_clicked',
    statusToggledOn: 'status_toggled_on',
    statusToggledOff: 'status_toggled_off',
    packageSelected: 'package_selected',
    standSelected: 'stand_selected',
    sharerProfileClicked: 'sharer_profile_clicked',
    saveClicked: 'save_clicked',
    saveFailed: 'save_failed',
    cancelClicked: 'cancel_clicked',
    taskOpened: 'task opened',
    taskClosed: 'task closed',
    linkClicked: 'link clicked',
    formOpened: 'form opened',
    fileDownloaded: 'file downloaded',
    taskCompleted: 'task completed',
  },
  contactType: {
    website: 'website',
    phone: 'phone',
    email: 'email',
    socialMedia: 'social media',
    accompanyingWebsite: 'accompanying website'
  },
  tabName: {
    documents: 'documents',
    products: 'products'
  }
};
